import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import { contactInfo } from '../data/mockData';

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-[#1a1d2e] border-t border-[#c4a35a]/20 py-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-12 h-12 rounded-full overflow-hidden bg-white border-2 border-[#c4a35a] flex-shrink-0">
                <img
                  src="/logo.png"
                  alt="Noble Law Firm"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#c4a35a]">{t.company}</h3>
                <p className="text-xs text-gray-300">{t.companyTagline}</p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold mb-4">{t.contact}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#c4a35a] flex-shrink-0 mt-1" />
                <div className="text-sm text-gray-400">
                  <p>{t.location}</p>
                  <p>{t.locationDetail}</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-[#c4a35a] flex-shrink-0 mt-1" />
                <div className="space-y-1">
                  {contactInfo.phones.map((phone) => (
                    <a key={phone} href={`tel:${phone}`} className="block text-sm text-gray-400 hover:text-[#c4a35a] transition-colors">
                      {phone}
                    </a>
                  ))}
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#c4a35a] flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm text-gray-400 hover:text-[#c4a35a] transition-colors">
                  {contactInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* WhatsApp CTA */}
          <div>
            <h4 className="text-white font-bold mb-4">{t.letsTalk}</h4>
            <a
              href={`https://wa.me/${contactInfo.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#c4a35a] text-[#0f1117] rounded-lg hover:bg-[#d4b36a] transition-colors font-medium"
            >
              <MessageCircle className="w-5 h-5" />
              {t.whatsapp}
            </a>
          </div>
        </div>

        <div className="border-t border-[#c4a35a]/20 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} {t.company}. {t.allRightsReserved}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
